import {
  UPDATE_SETTINGS,
  UPDATE_PROFILE,
  UPDATE_TAB,
  LOADING,
  MESSAGE_HANDLER,
  SHOW_SETTINGS,
  ZOOM_TO,
  RESET_SETTINGS,
  TOGGLE_DIRECTIONS,
  UPDATE_DATETIME,
  UPDATE_TRAFFIC_ENABLED,
  OPTIMIZING,
} from 'actions/types'
import {
  settingsInit,
  settingsInitTruckOverride,
  settingsInitAutoDpOverride,
  settingsInitTruckDpOverride,
} from 'Controls/settings-options'
import { getLocalDateTimeInputValue } from 'utils/dateTimeLocal'

const initialState = {
  activeTab: 0,
  showSettings: false,
  showDirectionsPanel: true,
  coordinates: [],
  loading: false,
  optimizing: false,
  message: {
    receivedAt: 0,
    type: null,
    icon: null,
    topic: null,
    description: null,
  },
  profile: 'car', // 'bicycle', 'pedestrian', 'car', 'truck', 'bus', 'motor_scooter', 'motorcycle'
  settings: { ...settingsInit },
  // datetime-local: local wall time in Redux; convert to UTC only for API calls
  dateTime: {
    type: -1,
    value: getLocalDateTimeInputValue(),
  },
  trafficEnabled: false,
}

export const common = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_HANDLER: {
      return {
        ...state,
        message: action.payload,
      }
    }
    case LOADING: {
      return {
        ...state,
        loading: action.payload,
      }
    }

    case OPTIMIZING: {
      return {
        ...state,
        optimizing: action.payload,
      }
    }

    case ZOOM_TO: {
      return {
        ...state,
        coordinates: action.payload,
      }
    }

    case SHOW_SETTINGS: {
      return {
        ...state,
        showSettings: !state.showSettings,
      }
    }

    case TOGGLE_DIRECTIONS: {
      return {
        ...state,
        showDirectionsPanel: !state.showDirectionsPanel,
      }
    }

    case UPDATE_SETTINGS: {
      const { name, value } = action.payload
      return {
        ...state,
        settings: {
          ...state.settings,
          [name]: value,
        },
      }
    }

    case RESET_SETTINGS: {
      return {
        ...state,
        settings: {
          ...(state.profile === 'truck'
            ? settingsInitTruckOverride
            : state.profile === 'autodp'
            ? settingsInitAutoDpOverride
            : state.profile === 'truckdp'
            ? settingsInitTruckDpOverride
            : settingsInit),
        },
      }
    }

    case UPDATE_TAB: {
      const { activeTab } = action.payload
      return {
        ...state,
        activeTab,
      }
    }

    case UPDATE_PROFILE: {
      const { profile } = action.payload
      return {
        ...state,
        profile,
      }
    }

    case UPDATE_DATETIME: {
      const { key, value } = action.payload
      return {
        ...state,
        dateTime: {
          ...state.dateTime,
          [key]: value,
        },
      }
    }

    case UPDATE_TRAFFIC_ENABLED: {
      return {
        ...state,
        trafficEnabled: !!action.payload,
      }
    }

    default: {
      return state
    }
  }
}
